import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["menuAnchorRef", "overlayProps", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React__default, { useContext, useCallback } from 'react';
import { AutocompleteContext } from './AutocompleteContext.js';
import { useRefObjectAsForwardedRef } from '../hooks/useRefObjectAsForwardedRef.js';
import VisuallyHidden from '../_VisuallyHidden.js';
import { useAnchoredPosition } from '../hooks/useAnchoredPosition.js';
import Overlay from '../Overlay/Overlay.js';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
} // TODO: consider making 'aria-labelledby' required


function AutocompleteOverlay(_ref) {
  var menuAnchorRef = _ref.menuAnchorRef,
      oldOverlayProps = _ref.overlayProps,
      children = _ref.children,
      newOverlayProps = _objectWithoutProperties(_ref, _excluded);

  var autocompleteContext = useContext(AutocompleteContext);

  if (autocompleteContext === null) {
    throw new Error('AutocompleteContext returned null values');
  }

  var overlayProps = _objectSpread(_objectSpread({}, oldOverlayProps), newOverlayProps);

  var inputRef = autocompleteContext.inputRef,
      scrollContainerRef = autocompleteContext.scrollContainerRef,
      selectedItemLength = autocompleteContext.selectedItemLength,
      setShowMenu = autocompleteContext.setShowMenu,
      _autocompleteContext$ = autocompleteContext.showMenu,
      showMenu = _autocompleteContext$ === void 0 ? false : _autocompleteContext$;

  var _useAnchoredPosition = useAnchoredPosition({
    side: 'outside-bottom',
    align: 'start',
    anchorElementRef: menuAnchorRef ? menuAnchorRef : inputRef
  }, [showMenu, selectedItemLength]),
      floatingElementRef = _useAnchoredPosition.floatingElementRef,
      position = _useAnchoredPosition.position;

  useRefObjectAsForwardedRef(scrollContainerRef, floatingElementRef);
  var closeOptionList = useCallback(function () {
    setShowMenu(false);
  }, [setShowMenu]);

  if (typeof window === 'undefined') {
    return null;
  }

  return showMenu ? /*#__PURE__*/React__default.createElement(Overlay, _extends({
    returnFocusRef: inputRef,
    preventFocusOnOpen: true,
    onClickOutside: closeOptionList,
    onEscape: closeOptionList,
    ref: floatingElementRef,
    top: position === null || position === void 0 ? void 0 : position.top,
    left: position === null || position === void 0 ? void 0 : position.left,
    sx: {
      overflow: 'auto'
    }
  }, overlayProps), children) :
  /*#__PURE__*/
  // HACK: This ensures AutocompleteMenu is still mounted when closing the menu and all of the hooks inside of it are still called.
  // A better way to do this would be to move the hooks to AutocompleteOverlay or somewhere that won't get unmounted.
  React__default.createElement(VisuallyHidden, {
    "aria-hidden": "true"
  }, children);
}

AutocompleteOverlay.displayName = 'AutocompleteOverlay';
export { AutocompleteOverlay as default };